import CopyIcon from '@mui/icons-material/FileCopyOutlined';
import SMSIcon from '@mui/icons-material/SmsOutlined';
import Box from '@mui/material/Box';
import MuiLink from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from 'components/IconButton/IconButton';
import Modal from 'components/Modal/Modal';
import TextField from 'components/form/TextInput';
import { EmailIcon } from 'components/icons';
import FEATURES from 'constants/features';
import useFeature from 'hooks/useFeature';
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDispatch } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { updateMessage } from 'store/modules/messages/actions';
import { snack } from 'utils/toast';

const ShareModal = ({ history, onClose, videoPage }) => {
  const dispatch = useDispatch();

  const hasSMS = useFeature(FEATURES.SMS);
  const hasEmail = useFeature(FEATURES.EMAIL);
  const videoUrl = videoPage.redirect.qr_code_text;

  const onShare = (type) => () => {
    dispatch(
      updateMessage({
        type,
        message:
          'Hi there {FIRST_NAME}, check out our new page!' + '\n' + videoUrl,
      }),
    );
  };

  return (
    <Modal title="Share Page" maxWidth="sm" onClose={onClose}>
      <Stack direction="row" spacing={2} mt={4}>
        <MuiLink
          onClick={onShare('email')}
          component={Link}
          to={`/messages/create`}
          sx={{ flex: 1 }}
        >
          <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
            <EmailIcon color="primary" />
            <Typography fontWeight={500}>Share by Email</Typography>
          </Paper>
        </MuiLink>
        <MuiLink
          onClick={onShare('sms')}
          component={Link}
          to={`/messages/create`}
          sx={{ flex: 1 }}
        >
          <Paper variant="outlined" sx={{ p: 2, textAlign: 'center' }}>
            <SMSIcon color="primary" />
            <Typography fontWeight={500}>Share by Text Message</Typography>
          </Paper>
        </MuiLink>
      </Stack>
      <Box>
        <TextField
          readOnly
          fullWidth
          label="Copy URL"
          value={videoUrl}
          endAdornment={
            <CopyToClipboard
              text={videoUrl}
              onCopy={() => snack.success('Link copied!')}
            >
              <IconButton edge="end" variant="text" icon={<CopyIcon />} />
            </CopyToClipboard>
          }
        />
      </Box>
    </Modal>
  );
};

export default withRouter(ShareModal);
